import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { READATHON_OVERALL_STATS } from './services/graphql';
import { Loader } from '@axeedge/go-teacher-components';
import styles from './Readathon.module.scss';

const Readathon = () => {
    const { data, loading, error } = useQuery(READATHON_OVERALL_STATS, {
        variables: {
            itemsCounter: 10,
            startFrom: '21/07/2025',
            endOn: '31/08/2025',
        },
    });

    if (loading) {
        return (
            <div className={styles.loaderContainer}>
                <Loader />
            </div>
        );
    }

    if (error) {
        return (
            <p className={styles.pageText}>
                Data could not be loaded. Please try again later.
            </p>
        );
    }

    if (
        data &&
        data.readathonOverallStats &&
        data.readathonOverallStats.length
    ) {
        return data.readathonOverallStats.map((stat, index) => (
            <div key={index + stat.schoolName} className={styles.readathonContainer}>
                <div>
                     {index > 2 ? index + 1 + '.' : ''} {stat.schoolName}
                </div>
            </div>
        ));
    } else {
        return <p className={styles.pageText}>No readathon stats available.</p>;
    }
};

export default Readathon;
